import * as React from "react";
import ProgressiveImage from "src/share/components/ProgressiveImage/ProgressiveImage";
import { generateImgSrc } from "src/share/utils/generateImgSrc";
import usePhotoViewer from "src/share/components/PhotoViewer/usePhotoViewer";

interface IBoundedFace {
  similarity: number;
  isMatch: boolean;
  box: React.CSSProperties;
}

const PHOTO_NOT_FOUND = "https://s3.us-east-2.amazonaws.com/caseview-children-assets/Images/no_photo_found.jpg";

const GSPImage = ({ src, width, height, faces }) => {
  const { handleZoomInImage } = usePhotoViewer();
  const boundedFaces: IBoundedFace[] =
  faces.length > 0
  ? faces.map((face) => {
    return {
      similarity: face.Confidence,
      isMatch: face.isMatch,
      box: {
        position: "absolute",
        width: `${face.BoundingBox.Width * 100}%`,
        height: `${face.BoundingBox.Height * 100}%`,
        top: `${face.BoundingBox.Top * 100}%`,
        left: `${face.BoundingBox.Left * 100}%`,
        border: face.isMatch ? "1px solid #0092A0" : "1px solid #dbae26"
      }
    };
  })
  : [];
  const handleImageError = (evt) => {
    evt.target.onerror = null;
    evt.target.src = PHOTO_NOT_FOUND;
  };
  return (
    <div className="geosearch-photo__picture">
      <div className="geosearch-photo__image-container bounding-boxes__container" onClick={() => handleZoomInImage({ source: src, boundingBoxes: boundedFaces })}>
        {src ? <ProgressiveImage id="gsp-image" src={src} onError={handleImageError} /> : <img src={generateImgSrc(width, height)} />}
        {boundedFaces.map((boundedFace, index) => (
          <div key={index}>
            <div className="bounding-box" style={boundedFace.box} />
            <span style={{ top: boundedFace.box.top, left: boundedFace.box.left }}>
              {boundedFace.isMatch && `${Math.round(boundedFace.similarity)}%`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(GSPImage);
